import moment from 'moment';
import i18n from '@/i18n';
import { validateAllField } from '@/utils/validate_v2';
import { STR_DATE_TIME } from '@/utils/format';

const OPTIONS_SERIAL_CODE_USED = () => {
    return [
        {
            id: 1,
            name: '当落ページを表示'
        },
        {
            id: 2,
            name: '利用済みの旨のみ表示'
        }
    ];
};

const configFormLottery = () => {
    return {
        start_date: {
            error: false,
            errorField: i18n.t('managerForm.settingSerialCode.tabLotteryCalendar'),
            errorText: '',
            typesValidate: ['required']
        },
        end_date: {
            error: false,
            errorField: i18n.t('managerForm.settingSerialCode.tabLotteryCalendar'),
            errorText: '',
            typesValidate: ['required']
        },
        start_time_winning: {
            format: 'HH:mm',
            valueType: 'format',
            placeholder: '',
            type: 'time',
            clearable: false,
            error: false,
            errorField: '',
            typesValidate: []
        },
        end_time_winning: {
            format: 'HH:mm',
            valueType: 'format',
            placeholder: '',
            type: 'time',
            clearable: false,
            error: false,
            errorField: '',
            typesValidate: []
        }
    };
};

const onValidDate = (initForm, configInit, check) => {
    //start valid date
    configInit.start_date.error = false;
    configInit.end_date.error = false;
    configInit.start_date.errorField = '';
    configInit.end_date.errorField = '';
    if (
        (configInit.start_date.typesValidate.includes('required') || configInit.end_date.typesValidate.includes('required')) &&
        (!initForm.start_date || !initForm.end_date)
    ) {
        check = false;
        configInit.start_date.error = true;
        configInit.end_date.error = true;
        configInit.end_date.errorField = i18n.t('validateField.requiredDate', {
            field: i18n.t('managerForm.settingSerialCode.tabLotteryCalendar')
        });
        return check;
    }
    const startDate = moment(initForm.start_date, STR_DATE_TIME);
    const endDate = moment(initForm.end_date, STR_DATE_TIME);
    if (!!initForm.start_date && !!initForm.end_date && !endDate.isSameOrAfter(startDate)) {
        check = false;
        configInit.start_date.error = true;
        configInit.start_date.errorText = i18n.t('validateField.compareDate');
    }
    // end valid date

    return check;
};
const onValidTime = (initForm, configInit, check) => {
    //start valid time
    configInit.start_time_winning.error = false;
    configInit.end_time_winning.error = false;
    configInit.start_time_winning.errorField = '';
    configInit.end_time_winning.errorField = '';
    if (
        (configInit.start_time_winning.typesValidate.includes('required') || configInit.end_time_winning.typesValidate.includes('required')) &&
        (!initForm.start_time_winning || !initForm.end_time_winning)
    ) {
        check = false;
        configInit.start_time_winning.isRequired = false;
        configInit.end_time_winning.isRequired = false;
        configInit.start_time_winning.error = true;
        configInit.end_time_winning.error = true;
        configInit.start_time_winning.errorField = i18n.t('validateField.required', {
            field: i18n.t('managerForm.settingSerialCode.winningTimeSetting')
        });
        return check;
    }

    const startTime = moment(initForm.start_time_winning, 'HH:mm');
    const endTime = moment(initForm.end_time_winning, 'HH:mm');
    if (!!initForm.start_time_winning && !!initForm.end_time_winning && !endTime.isSameOrAfter(startTime)) {
        check = false;
        configInit.end_time_winning.error = true;
        configInit.end_time_winning.errorField = i18n.t('validateField.compareTime');
    }
    // end valid time

    return check;
};

const handleValidSettingLottery = (initForm, configInit) => {
    let check = validateAllField(initForm, configInit);
    check = onValidDate(initForm, configInit, check) && check;
    check = onValidTime(initForm, configInit, check) && check;
    return check;
};

export { OPTIONS_SERIAL_CODE_USED, configFormLottery, handleValidSettingLottery, onValidDate, onValidTime };
